import { put } from 'redux-saga/effects';

function* requestClose() {
  yield put({ type: 'CLOSE_SNACKBAR' });
}

function* requestShow(action) {
  yield put({ type: 'SHOW_SNACKBAR', payload: action.payload.message });
}

const Actions = {
  requestClose,
  requestShow,
}

const Types = {
  close: 'REQUEST_SNACKBAR_CLOSE',
  show: 'REQUEST_SNACKBAR_SHOW',
}

export {
  Actions,
  Types,
}
